import Link from "next/link";
import { getExploreAndCloneLink } from "../../../lib/utils";
import { menuList } from "../../../static/menuList";
import Container from "../Container";
import Loader from "../../../components/elements/Loader";
import { useEffect, useState } from "react";
import axios from "axios";
import endPoints from "../../../utility/endpoints";
import description from "./description";
import { toast } from "react-toastify";

const SubMenu = ({ hoveredLink, close }) => {
  const menuData = menuList(hoveredLink);
  const { cloneLink, exploreLink, type } = getExploreAndCloneLink(hoveredLink);
  const noDataInLists = menuData.every((menu) => menu.list.length === 0);

  const [skills, setSkills] = useState([]);
  const skillstat = async (e) => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    const { data } = await axios({
      url: `${endPoints.baseUrl}/twin/getETbyLeadPlatform`,
      method: "POST",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },
      data: {
        leadPlatform: type,
      },
    });

    if (data.code === 200) {
      // Filter soft skill data
      setSkills(data);
    } else if (data.code === 403 || data.code === 401) {
      toast.warn("Session Expired");
      window.location.reload();
    }
  };

  useEffect(() => {
    skillstat();
  }, []);
  return (
    <div
      onMouseLeave={() => close()}
      className={`absolute top-16 bg-white left-0 w-screen overflow-x-hidden subMenu ${hoveredLink && "active"}`}
    >
      <Container className="pt-10 pb-16">
        {noDataInLists ? (
          <div className="text-center my-5">
            <Loader />
          </div>
        ) : (
          <>
            {/* Description */}
            <div className="mb-5 w-[60%]">{description[type]}</div>
            {/* Links */}
            <div className="grid grid-cols-2 gap-10">
              {menuData.map((menu, index) => (
                <div key={menu.label}>
                  {index === 0 ? (
                    <Link
                      href={`/Employeetwinsdetail?empTwinId=${skills.etid}&name=${skills.etname}&leadPlatform=${type}`}
                      className={``}
                    >
                      <a
                        className="text-[#5A5A5A]  mb-4 block"
                        onClick={() => close()}
                      >
                        {menu.label}
                      </a>
                    </Link>
                  ) : (
                    <h4 className={`text-[#5A5A5A]  mb-4`}>{menu.label}</h4>
                  )}

                  <ul className={`${index === 0 ? "space-y-4" : "space-y-2"}`}>
                    {menu.list.map((list) => (
                      <li key={list.label}>
                        <Link className="" href={list?.url || "#"}>
                          <a
                            target="_blank"
                            className={` ${index === 0 ? "text-xl font-medium" : "text-xs text-gray-500 font-medium"} hover:text-main transition-all`}
                          >
                            {list.label}
                          </a>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="mt-7">
              <Link
                href={`/checkout/individual?empTwinId=${skills.etid}&name=${skills.etname}&image=${skills.etphoto}`}
              >
                <a
                  onClick={() => close()}
                  className="bg-red-500 text-white px-10 py-2 rounded-full"
                >
                  Clone
                </a>
              </Link>
            </div>
          </>
        )}
      </Container>
    </div>
  );
};

export default SubMenu;

